import { useTranslation } from 'react-i18next';
import { ContentTemplate, KeyValue, SectionHeader } from 'web-library';
import { DataArchivalDetail } from '../../../../../api-refactored/data-archival/useGetDataArchivalDetail';
import FormHeader from '../../../../../components/form-items/FormHeader';
import FormTableDataGroup from '../FormTableDataGroup';

interface DataArchivalDetailProps {
  archivalDetail: DataArchivalDetail;
}

const DataArchivalDetailComponent = ({ archivalDetail }: DataArchivalDetailProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ContentTemplate isDividerBottom isContinuable>
        <SectionHeader title={t('admin->>DataArchival.DataArchivalDetails')} />
        <KeyValue
          keyText={t('admin->>DataArchival.ViewExamYear')}
          valueText={archivalDetail?.content.examYear}
        />
      </ContentTemplate>

      <ContentTemplate type="full" isDividerBottom isContinuable continuous>
        <FormHeader title={t('admin->>DataArchival.DataGroups')} />

        <FormTableDataGroup template={archivalDetail?.content.content} editable={false} />
      </ContentTemplate>
    </>
  );
};

export default DataArchivalDetailComponent;
